import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Projects: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedLocation, setSelectedLocation] = useState('all');

  return (
    <div className="py-12 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold">Proiecte Disponibile</h1>
          <Link
            to="/publish-project"
            className="px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors"
          >
            Publică un Proiect
          </Link>
        </div>

        {/* Filters */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Categorie
              </label>
              <select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary"
              >
                <option value="all">Toate categoriile</option>
                <option value="it">IT & Digitalizare</option>
                <option value="agricultura">Agricultură</option>
                <option value="energie">Energie</option>
                <option value="turism">Turism</option>
                <option value="infrastructura">Infrastructură</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Locație
              </label>
              <select
                value={selectedLocation}
                onChange={(e) => setSelectedLocation(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary"
              >
                <option value="all">Toate locațiile</option>
                <option value="bucuresti">București</option>
                <option value="cluj">Cluj</option>
                <option value="timisoara">Timișoara</option>
                <option value="iasi">Iași</option>
                <option value="constanta">Constanța</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Buget Min
              </label>
              <input
                type="number"
                placeholder="Min"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Buget Max
              </label>
              <input
                type="number"
                placeholder="Max"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary"
              />
            </div>
          </div>
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Project Card 1 */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <div className="p-6">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mr-4">
                  <span className="text-primary font-semibold">IT</span>
                </div>
                <div>
                  <h3 className="font-semibold">Digitalizare SME</h3>
                  <p className="text-sm text-gray-500">București</p>
                </div>
              </div>
              <p className="text-gray-600 mb-4">Căutăm consultant pentru digitalizarea proceselor companiei și implementarea unui sistem ERP.</p>
              <div className="flex justify-between items-center">
                <span className="text-primary font-semibold">Buget: 50.000€</span>
                <Link
                  to="/projects/1"
                  className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors"
                >
                  Vezi detalii
                </Link>
              </div>
            </div>
          </div>

          {/* Project Card 2 */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <div className="p-6">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mr-4">
                  <span className="text-primary font-semibold">AG</span>
                </div>
                <div>
                  <h3 className="font-semibold">Agricultură Modernă</h3>
                  <p className="text-sm text-gray-500">Cluj</p>
                </div>
              </div>
              <p className="text-gray-600 mb-4">Proiect de modernizare a fermei cu tehnologii IoT și sisteme de irigare automată.</p>
              <div className="flex justify-between items-center">
                <span className="text-primary font-semibold">Buget: 75.000€</span>
                <Link
                  to="/projects/2"
                  className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors"
                >
                  Vezi detalii
                </Link>
              </div>
            </div>
          </div>

          {/* Project Card 3 */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <div className="p-6">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mr-4">
                  <span className="text-primary font-semibold">EN</span>
                </div>
                <div>
                  <h3 className="font-semibold">Energie Verde</h3>
                  <p className="text-sm text-gray-500">Timișoara</p>
                </div>
              </div>
              <p className="text-gray-600 mb-4">Instalare sisteme fotovoltaice pentru companie și implementare management energetic.</p>
              <div className="flex justify-between items-center">
                <span className="text-primary font-semibold">Buget: 100.000€</span>
                <Link
                  to="/projects/3"
                  className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors"
                >
                  Vezi detalii
                </Link>
              </div>
            </div>
          </div>

          {/* Project Card 4 */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <div className="p-6">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mr-4">
                  <span className="text-primary font-semibold">TR</span>
                </div>
                <div>
                  <h3 className="font-semibold">Turism Rural</h3>
                  <p className="text-sm text-gray-500">Brașov</p>
                </div>
              </div>
              <p className="text-gray-600 mb-4">Dezvoltare agroturism și promovare turistică pentru pensiunea din zona rurală.</p>
              <div className="flex justify-between items-center">
                <span className="text-primary font-semibold">Buget: 45.000€</span>
                <Link
                  to="/projects/4"
                  className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors"
                >
                  Vezi detalii
                </Link>
              </div>
            </div>
          </div>

          {/* Project Card 5 */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <div className="p-6">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mr-4">
                  <span className="text-primary font-semibold">IN</span>
                </div>
                <div>
                  <h3 className="font-semibold">Infrastructură Smart City</h3>
                  <p className="text-sm text-gray-500">Iași</p>
                </div>
              </div>
              <p className="text-gray-600 mb-4">Implementare sisteme de iluminat inteligent și management al traficului.</p>
              <div className="flex justify-between items-center">
                <span className="text-primary font-semibold">Buget: 150.000€</span>
                <Link
                  to="/projects/5"
                  className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors"
                >
                  Vezi detalii
                </Link>
              </div>
            </div>
          </div>

          {/* Project Card 6 */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <div className="p-6">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mr-4">
                  <span className="text-primary font-semibold">IT</span>
                </div>
                <div>
                  <h3 className="font-semibold">Cybersecurity</h3>
                  <p className="text-sm text-gray-500">Constanța</p>
                </div>
              </div>
              <p className="text-gray-600 mb-4">Implementare sisteme de securitate cibernetică pentru companie.</p>
              <div className="flex justify-between items-center">
                <span className="text-primary font-semibold">Buget: 60.000€</span>
                <Link
                  to="/projects/6"
                  className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors"
                >
                  Vezi detalii
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Pagination */}
        <div className="mt-12 flex justify-center">
          <nav className="flex items-center space-x-2">
            <button className="px-3 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50">
              Anterior
            </button>
            <button className="px-3 py-2 border border-primary bg-primary text-white rounded-md text-sm font-medium">
              1
            </button>
            <button className="px-3 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50">
              2
            </button>
            <button className="px-3 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50">
              3
            </button>
            <button className="px-3 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50">
              Următorul
            </button>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Projects; 